export const PERMISSION_CODE = {
  ADMIN: "ADMIN",
  ANALYTICS: "ANALYTICS",
  REALTIME: "REALTIME",
  /** Sửa số lượng / đơn giá dòng vật tư trên đơn — kể cả đơn đã hoàn tất (trừ huỷ). Giám sát KHÔNG có. */
  ORDER_ITEM_QUANTITY_EDIT: "ORDER_ITEM_QUANTITY_EDIT",
  /** Xuất Excel danh sách đơn hàng (chạy nền, theo bộ lọc đang chọn). */
  ORDER_EXPORT: "ORDER_EXPORT",
  /** Sửa ảnh xác nhận các bước (lấy hàng / kiểm đếm / giao) — đơn đang chạy lẫn đã hoàn thành, trừ huỷ. */
  ORDER_PHOTO_EDIT: "ORDER_PHOTO_EDIT",
  /** "Huỷ SQTM": huỷ khoản thu + lần nộp tiền mặt đã nộp sổ quỹ của đơn hoàn tất, để đổi được hình thức thanh toán. */
  DRIVER_CASH_DEPOSIT_CANCEL: "DRIVER_CASH_DEPOSIT_CANCEL",
};
